/**
 * Created by claudio iozzia on 14/07/2017.
 */
import {IAppTypeMap, Ic} from "./common";
import {ISpec} from "./ISpec";
import {edsEnvConfiguration} from "../../environments/edsEnvConfiguration";
import {tassign, Utils} from "../common/utils";
import {isNullOrUndefined} from "util";
import {XmlUtils} from "../common/xmlUtils";
import {IeDsFile} from "./user-info";
import * as pako from "pako";
import {HttpClient} from "@angular/common/http";
import {Observable, of, throwError} from "rxjs";
import {map, mergeMap, timeout} from "rxjs/operators";
import {AuthService} from "../auth/auth.service";

export interface IeDsUrl {
  base: string;
  app: string;
  msg: string;
}

export class SpecToDesign {
  public static toDesign_xPower(
    ic: Ic,
    appType: string,
    spec: ISpec<number>
  ): string {
    const specData = {
      data: {
        application: appType,
        specs: {
          ic: ic.key,
          input: {
            v: {
              min: spec.input.min,
              max: spec.input.max
            },
            f: spec.input.freq
          },
          output: spec.output.outputs.map(x => {
            return {
              v: Math.abs(x.voltage),
              r: (ic.key && ic.key.search(/:pfc/i) >= 0 ) ? undefined :  2,     // if pfc in key ripple undefined to take the default value else 2%
              i: x.current
            };
          })
        }
      },
      action: "new_design"
    };

    return JSON.stringify(specData);
  }

  /*
  * {"action":"new_design","data":{"specs":{"led":{"PN":"Custom","Rd":null,"Manufacturer":"","IF":0.1,"Color":"","VFMax":null,"Family":"","VF":500},"input":{"v":{"min":185,"max":265},"f":50},"numLed":{"parallel":1,"serie":2},"ic":"HVLED001A:hpf_qr_flyback"},"application":"LED_acdc"}}
  * */
  public static toDesign_xLED(
    ic: Ic,
    appType: string,
    spec: ISpec<number>
  ): string {
    const ledInfo = spec.output.ledParam.selectedLed;
    const specData = {
      data: {
        application: appType,
        specs: {
          ic: ic.key,
          input: {
            v: {
              min: spec.input.min,
              max: spec.input.max
            },
            f: spec.input.freq
          },
          led: {
            VF: spec.output.outputs[0].voltage,
            IF: spec.output.outputs[0].current,
            PN: ledInfo === null ? "Custom" : ledInfo.PN,
            Rd:
              isNullOrUndefined(spec.output.ledParam.rd) ||
              isNaN(spec.output.ledParam.rd)
                ? null
                : spec.output.ledParam.rd,
            Manufacturer: ledInfo === null ? "" : ledInfo.Manufacturer,
            Color: ledInfo === null ? "" : ledInfo.Color,
            VFMax: ledInfo === null ? "" : ledInfo.VFMax,
            Family: ledInfo === null ? "" : ledInfo.Family
          },
          numLed: {
            parallel: spec.output.ledParam.parallel,
            serie: spec.output.ledParam.serial
          }
        }
      },
      action: "new_design"
    };

    return JSON.stringify(specData);
  }

  public static specToLog(spec: ISpec<number>, appType: string) {
    const ledInfo = spec.output.ledParam.selectedLed;

    return appType.toLowerCase().includes("led")
    ? ({input: spec.input, led: {
              VF: spec.output.outputs[0].voltage,
              IF: spec.output.outputs[0].current,
              PN: ledInfo === null ? "Custom" : ledInfo.PN,
              Rd:
                isNullOrUndefined(spec.output.ledParam.rd) ||
                isNaN(spec.output.ledParam.rd)
                  ? undefined
                  : spec.output.ledParam.rd}})
    : ({input: spec.input, output: spec.output.outputs.reduce((acc, x, i) => ({...acc, ...{[`${i}`]: x}}), {})});
  }
  private static _startDesignUrl(
    ic: Ic,
    spec: ISpec<number>,
    appType: string,
    url: string
  ): string {
    const msg = appType.toLowerCase().includes("led")
      ? SpecToDesign.toDesign_xLED(ic, appType, spec)
      : SpecToDesign.toDesign_xPower(ic, appType, spec);

    // window.open(url + "?msg=" + msg);
    // const urlWithLogin = edsEnvConfiguration.login_url + encodeURIComponent( url + "?msg=" + msg);
    const urlWithLogin =  url + "?msg=" + encodeURIComponent( msg);
    return urlWithLogin;
  }

  public static startDesignURL(
    ic: Ic,
    spec: ISpec<number>,
    _map: IAppTypeMap,
    appName: string
  ): Observable<{ic: Ic, url: string, base: string}> {
    return new Observable<{ic: Ic, url: string, base: string}>(observer => {
      if (_map === null) {
        observer.error("Error on load app type mapping");
      } else {
        const _appTypeName: string = Utils.getFieldValue(
          ic,
          "app_name",
          appName
        );

        const _appTypeMap = _map.apps.find(
          x =>
            x.app.name.toLowerCase() ===
            (_appTypeName !== "" ? _appTypeName : appName).toLowerCase()
        );
        if (!isNullOrUndefined(_appTypeMap)) {
          const baseUrl = isNullOrUndefined(_appTypeMap.app.baseUrl) ? edsEnvConfiguration.edsUrl + _appTypeMap.app.url : _appTypeMap.app.baseUrl + _appTypeMap.app.url;
          const urlToOpen = SpecToDesign._startDesignUrl(
            ic,
            spec,
            _appTypeMap.app.name.toLowerCase(), // _appTypeMap.app.name.toLowerCase().replace(/acdc_lite_html|acdc_qr_html/ig, 'acdc_html'),          // This to manage the acdc_html and acdc_lite_html both has the same application type
            baseUrl
          );
          observer.next({ic, url: urlToOpen, base: baseUrl});
          observer.complete();
        } else {
          observer.error("Error no valid app type");
        }
      }
    });
  }

  private static toImportMsg(name: string, fileContent: string): string {
    const zipContent = pako.gzip(fileContent, {to: "string"});
    const encodeToBase64 = window.btoa(zipContent);
    const msgData = {
      action: "import",
      data: {
        design_name: name.split(".prj")[0],
        //// CLD 180823 in eDesign Modules the import project, when passed the json in the url,
        //// the AS3 function URLUtils stingToObject  fail if the field design contains '='
        // ----->>> changed use encodeUri component
        // ----->>> design: encodeToBase64.replace(/=/g,'%3D')
        //
        design: encodeToBase64
      }
    };
    return JSON.stringify(msgData);
  }

  private static getAppTypeFromContent(
    fileContentJSON: any,
    _map: IAppTypeMap
  ): Observable<IeDsUrl> {
      // <eDesignStudio Description="test project" ver="2" app="acdc">
      // -----old format
      // <dcdcPrj Description="">
      //      const searchApp = /^<eDesignStudio Description=".*" ver="(.*)" app="(\w+)"/;
      //      const _appTypeNameGroup = searchApp.exec(fileContent);
      let appName = Utils.getFieldValue(fileContentJSON, "eDesignStudio.app");

      if (appName === null) { // update to support new format
        appName = Utils.getFieldValue(fileContentJSON, "eDesignSuite.app");
      }
      if (appName === null) {
        if (Utils.getFieldValue(fileContentJSON, "dcdcPrj") !== null) {
          appName = "dcdc";
        } // default application for old project stile
      }

      if (_map === null) {
        return throwError("Error on load app type mapping");
      }
      if (appName === null) {
        return throwError("Invalid file format");
      }

      const _appTypeMap = _map.apps.find(
        x => x.app.name.toLowerCase() === appName.toLowerCase()
      );

      if (isNullOrUndefined(_appTypeMap)) {
        return throwError(`Error no valid app type (${appName})`);
      }
      const ret: IeDsUrl = {
        // base: ((_appTypeMap.app.name.toLowerCase() === 'acswitch') ? edsEnvConfiguration.edsServerURL : edsEnvConfiguration.edsUrl),
        base: isNullOrUndefined(_appTypeMap.app.baseUrl) ? edsEnvConfiguration.edsUrl : _appTypeMap.app.baseUrl,
        app: _appTypeMap.app.url,
        msg: null, // will be append in the call function
      };
      return of(ret);
  }

  public static importUserLocalProject(
    fileName: string,
    fileContent: string,
    mapType: IAppTypeMap
  ): Observable<IeDsUrl> {
    return of(fileContent).pipe(
      XmlUtils.toJSON,
      mergeMap(x => SpecToDesign.getAppTypeFromContent(x, mapType)),
      map(appType => tassign(appType, {msg: SpecToDesign.toImportMsg(fileName, fileContent)}))
    );
  }

  // private static toImportExampleProject(file: IeDsFile): string {
  //   const msgData = {
  //     action: "import",
  //     data: {
  //       design_name: file.path,
  //       url: file.url
  //     }
  //   };
  //
  //   return JSON.stringify(msgData);
  // }

  // public static openExampleProject(
  //   http: HttpClient,
  //   file: IeDsFile,
  //   mapType: IAppTypeMap
  // ): Observable<IeDsUrl> {
  //   const remoteUrl = file.url;
  //   return XmlUtils.loadXmlFile(http, remoteUrl).pipe(
  //     mergeMap(x => SpecToDesign.getAppTypeFromContent(x, mapType)),
  //     map(appType => tassign(appType, {msg: SpecToDesign.toImportExampleProject(file)}))
  //   );
  // }

  private static toOpenUserProject(file: IeDsFile): string {
    const msgData = {
      action: "open_id",
      data: {
        path: file.path,
        id: file.id
      }
    };
    return JSON.stringify(msgData);
  }

  public static openUserProject(
    httpAuth: AuthService,
    file: IeDsFile,
    mapType: IAppTypeMap
  ): Observable<IeDsUrl> {
    const remoteUrl = edsEnvConfiguration.userFile + file.id;

    if (!remoteUrl || remoteUrl === '' || !file || !file.id || file.id === '') {
      return throwError("Empty file name not valid");
    }

    return httpAuth.get(remoteUrl).pipe(
      timeout(10000),   // 10s timeout
      XmlUtils.toJSON,
      mergeMap(x => SpecToDesign.getAppTypeFromContent(x, mapType)),
      map(appType => tassign(appType, {msg: SpecToDesign.toOpenUserProject(file)}))
    );
  }

  public static getUserProject(
    httpAuth: AuthService,
    file: IeDsFile,
  ): Observable<string> {
    const remoteUrl = edsEnvConfiguration.userFile + file.id;

    if (!remoteUrl || remoteUrl === '' || !file || !file.id || file.id === '') {
      return throwError("Empty file name not valid");
    }

    return httpAuth.get(remoteUrl).pipe(
      XmlUtils.strStrToStrObj
    );
  }

  private static toDeleteUserProject(file: IeDsFile): string {
    const msgData = {
      action: "open_id",
      data: {
        path: file.path,
        id: file.id
      }
    };
    return JSON.stringify(msgData);
  }

  public static deleteUserProject(httpAuth: AuthService, file: IeDsFile): Observable<any> {
    const remoteUrl = edsEnvConfiguration.removeUserFile + file.id;

    if (!remoteUrl || remoteUrl === '' || !file || !file.id || file.id === '') {
      return throwError("Empty file name not valid");
    }

    return httpAuth.delete(remoteUrl);
  }
}
